import { z } from "zod";
export const WorkspaceRoleSchema = z.enum([
    "Owner",
    "Admin",
    "Creator",
    "Viewer",
    "Billing",
    "Guest",
    "Contributor",
]);
export const WorkspaceRole = WorkspaceRoleSchema.enum;
export const WorkspaceSeatType = z.enum(["Full", "Builder", "None"]);
export function deriveWorkspaceSeatTypeFromRole(role) {
    switch (role) {
        case "Owner":
        case "Admin":
        case "Creator":
        case "Contributor":
            return "Full";
        case "Viewer":
        case "Billing":
        case "Guest":
            return "None";
    }
}
/**
 * Roles allowed for each workspace seat type
 * Single source of truth for valid seat/role pairs.
 */
export const SEAT_TYPE_ALLOWED_ROLES = {
    Full: [
        WorkspaceRole.Owner,
        WorkspaceRole.Admin,
        WorkspaceRole.Creator,
        WorkspaceRole.Contributor,
    ],
    Builder: [WorkspaceRole.Owner, WorkspaceRole.Admin, WorkspaceRole.Creator],
    None: [WorkspaceRole.Viewer, WorkspaceRole.Billing],
};
const SEAT_TYPE_ALLOWED_ROLE_SETS = {
    Full: new Set(SEAT_TYPE_ALLOWED_ROLES.Full),
    Builder: new Set(SEAT_TYPE_ALLOWED_ROLES.Builder),
    None: new Set(SEAT_TYPE_ALLOWED_ROLES.None),
};
/**
 * Check if the seat type is valid for the given role and return boolean.
 */
export function isValidRoleSeatPair(role, seatType) {
    return SEAT_TYPE_ALLOWED_ROLE_SETS[seatType].has(role);
}
export function getAllowedRolesForSeatType(seatType) {
    return [...SEAT_TYPE_ALLOWED_ROLES[seatType]];
}
